import * as React from 'react';
import { createPortal } from 'react-dom';
import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit';
import { RoundButton } from '../../RoundButton';

import * as styles from './FullscreenControls.css';

export type TDirection = '>' | '<';

export interface IFullscreenControlsProps {
  onControlClick(direction: TDirection): void;
}

export function FullscreenControls({ onControlClick }: IFullscreenControlsProps) {
  return createPortal(
    <div className={styles['container']}>
      <RoundButton buttonStyles={styles['left_arrow']} onClick={() => onControlClick('<')}>
        <IconChevronLeft16 color="white_100" />
      </RoundButton>

      <RoundButton buttonStyles={styles['right_arrow']} onClick={() => onControlClick('>')}>
        <IconChevronRight16 color="white_100" />
      </RoundButton>
    </div>,
    document.body,
  );
}
